module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-banner.864bd042.png";